// Phase M — "auto-save memories from chats" is a per-user preference with
// nowhere server-side to live: llm_settings (where auto_title/stream_tokens
// live) is a single-row *admin-global* table, not per-user, and this app has
// no other per-user settings store. Client-side localStorage, same posture
// as chatModel.ts's last-model-selection and SettingsView's theme key.
const AUTO_MEMORY_EXTRACTION_KEY = "chatclient.autoMemoryExtraction";

/** Default true — matches the plan's "default on when use_memory is on". */
export function loadAutoMemoryExtraction(): boolean {
  try {
    const v = localStorage.getItem(AUTO_MEMORY_EXTRACTION_KEY);
    return v === null ? true : v === "true";
  } catch {
    return true;
  }
}

export function saveAutoMemoryExtraction(value: boolean): void {
  try {
    localStorage.setItem(AUTO_MEMORY_EXTRACTION_KEY, String(value));
  } catch {
    // Storage is a convenience, not a requirement for the current session.
  }
}
